export const READ_FULL_DISCLAIMER = 'Read Full Disclaimer';
export const DISCLAIMER = 'Disclaimer';
export const OPEN_ERROR_MODAL = 'Open Error Modal';
export const WENT_WRONG = 'Oops! Something went wrong.';
export const ERROR_MESSAGE = 'We’re sorry, but an unexpected error has occured';
export const PLEASE_TRY_AGAIN = 'Please try again';
export const OK = 'OK';
export const ENGEN = 'engen';
